import { render, staticRenderFns } from "./sim.vue?vue&type=template&id=37c06511&scoped=true&"
import script from "./sim.vue?vue&type=script&lang=js&"
export * from "./sim.vue?vue&type=script&lang=js&"
import style0 from "./sim.vue?vue&type=style&index=0&id=37c06511&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c06511",
  null
  
)

export default component.exports